import { useState } from "react";

interface ShareBarProps {
  title: string;
}

export default function ShareBar({ title }: ShareBarProps) {
  const [toast, setToast] = useState("");

  const showToast = (msg: string) => {
    setToast(msg);
    window.setTimeout(() => setToast(""), 2000);
  };

  const currentUrl = () => window.location.href;

  const copyLink = () => {
    const url = currentUrl();
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(url).then(
        () => showToast("链接已复制"),
        () => showToast("复制失败，请手动复制"),
      );
    } else {
      showToast("链接已复制");
    }
  };

  const shareTo = (platform: string) => {
    const url = encodeURIComponent(currentUrl());
    const text = encodeURIComponent(title);
    let target = "";
    if (platform === "weibo") target = `https://service.weibo.com/share/share.php?url=${url}&title=${text}`;
    if (platform === "x") target = `https://twitter.com/intent/tweet?url=${url}&text=${text}`;
    if (platform === "qq") target = `https://connect.qq.com/widget/shareqq/index.html?url=${url}&title=${text}`;
    if (target) window.open(target, "_blank", "noopener,noreferrer");
    showToast("已打开分享窗口");
  };

  const btn =
    "w-9 h-9 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-800 hover:bg-secondary-500 hover:text-background-50 transition-colors cursor-pointer";

  return (
    <div className="relative flex items-center flex-wrap gap-2">
      <span className="text-sm font-medium text-foreground-600 mr-1">分享</span>
      <button type="button" aria-label="复制链接" onClick={copyLink} className={btn}>
        <i className="ri-link"></i>
      </button>
      <button type="button" aria-label="分享到微博" onClick={() => shareTo("weibo")} className={btn}>
        <i className="ri-weibo-fill"></i>
      </button>
      <button type="button" aria-label="分享到 X" onClick={() => shareTo("x")} className={btn}>
        <i className="ri-twitter-x-fill"></i>
      </button>
      <button type="button" aria-label="分享到 QQ" onClick={() => shareTo("qq")} className={btn}>
        <i className="ri-qq-fill"></i>
      </button>

      {toast && (
        <div className="fixed bottom-8 left-1/2 -translate-x-1/2 z-[60] px-4 py-2 rounded-md bg-primary-950 text-background-50 text-sm wf-fade-up">
          {toast}
        </div>
      )}
    </div>
  );
}